import type { RegistrationForm } from 'src/types/registration';

export const ABOUT_YOU_VALIDATION_FORM_FIELDS: Array<keyof RegistrationForm> = [
  'companyName',
  'registrationType',
  'partnerSource',
  'partnerAgreesToProvideId',
];

export const ABOUT_YOU_VALIDATION_CONTACT_FIELDS = [
  'address',
  'address.country',
  'address.addressLine1',
  'address.addressLine2',
  'address.addressTown',
  'address.postcode',
  'telephone',
  'telephone.telephone',
  'telephone.dialingCode',
];

export const ABOUT_YOU_VALIDATION_RULE_NAMES = [
  ...ABOUT_YOU_VALIDATION_FORM_FIELDS,
  ...ABOUT_YOU_VALIDATION_CONTACT_FIELDS,
];

type FormValidationUnionFields = (typeof ABOUT_YOUR_BUSINESS_VALIDATION_FORM_FIELDS)[number];

const ABOUT_YOUR_BUSINESS_PLANNING_FIELDS = [
  'deliverAreas.uk',
  'deliverAreas.selfDelivery',
  'deliverAreas.selfDeliveryAreas',
  'instagramHandle',
  'pipelinePlans.provided',
  'pipelinePlans.details',
  'salesChannels.onlineStores.uses',
] as const;

type PlanningValidationFields = Record<
  (typeof ABOUT_YOUR_BUSINESS_PLANNING_FIELDS)[number],
  string
>;

export type AboutYourBusinessValidation = Pick<RegistrationForm, FormValidationUnionFields> &
  PlanningValidationFields;

const ABOUT_YOUR_BUSINESS_VALIDATION_FORM_FIELDS: Array<keyof RegistrationForm> = [
  'website',
  'leadinTime',
  'packagingAttachments',
];

export const PACKAGING_ATTACHMENTS_VALIDATION_RULE_NAMES = ['packagingAttachments.notUploaded'];

export const ABOUT_YOUR_BUSINESS_VALIDATION_RULE_NAMES = [
  ...ABOUT_YOUR_BUSINESS_VALIDATION_FORM_FIELDS,
  ...ABOUT_YOUR_BUSINESS_PLANNING_FIELDS,
  ...PACKAGING_ATTACHMENTS_VALIDATION_RULE_NAMES,
];

export interface AboutYourProductsValidation extends Pick<RegistrationForm, 'productCategories'> {
  'certification.required': string;
}

export const ABOUT_YOUR_PRODUCT_VALIDATION_RULE_NAMES: Array<keyof AboutYourProductsValidation> = [
  'productCategories',
  'certification.required',
];
